import { useState } from 'react';
import { Button } from '../ui/atoms/Button';
import { Input } from '../ui/atoms/Input';

interface AccessCodeGateProps {
  onSuccess: (code: string) => void;
}

export function AccessCodeGate({ onSuccess }: AccessCodeGateProps) {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!code.trim()) {
      setError('Please enter an access code');
      return;
    }

    setLoading(true);
    try {
      onSuccess(code.trim());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-md border border-gray-200 w-full max-w-md p-8">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo/dark-logo.png" alt="Invirtus" className="w-10 h-10 mb-3" />
          <h1 className="font-heading text-dark-invirtus text-2xl font-bold">
            Sales Demo
          </h1>
          <p className="font-body text-dark-invirtus/60 text-sm mt-1">
            Enter access code to continue
          </p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            type="password"
            placeholder="Access code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoComplete="off"
            disabled={loading}
            error={error ?? undefined}
          />
          <Button
            htmlType="submit"
            intent="primary"
            loading={loading}
            className="w-full"
          >
            Continue
          </Button>
        </form>
      </div>
    </div>
  );
}
